import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

// Views :-
// Error Pages
import Error404 from "@/views/Errors/Error404.vue";
import Error500 from "@/views/Errors/Error500.vue";
import SystemUpdate from "@/views/Errors/SystemUpdate.vue";

// Authentication pages
import Auth from "@/views/Auth/Auth.vue";
import LoginPage from "@/views/Auth/LoginPage.vue";
import ForgetPassword from "@/views/Auth/ForgetPassword.vue";
import ShiftClosePage from "../views/Auth/ShiftClosePage.vue";
import StartShiftPage from "../views/Auth/StartShiftPage.vue";
import AutoLogin from "../views/Auth/AutoLogin.vue";


// Authorized Page
import Dashboard from "@/views/POS/Dashboard.vue";
import {POSRoutes} from "./POSRoutes";



Vue.use(VueRouter);

// Routes :-
const routes = [
  // Authorized :-
  {
    path: "/",
    component: Dashboard,
    beforeEnter: (to, from, next) => {
      store.dispatch("checkAppVersion").then();
      store.dispatch("checkAuth").then();
      console.log("beforeEnter and checkAuth", store.state.isAuth);
      if (store.state.isAuth === true) {
        store.dispatch("getUserData").then();
        next();
      } else {
        router.push("/login").then();
      }
    },
    children: [...POSRoutes],
  },
  // Not Authorized :-
  {
    path: "/auth",
    component: Auth,
    children: [
      {
        path: "/",
        name: "LoginPageAuth",
        component: LoginPage,
        meta: {
          title: "login",
        },
      },
      {
        path: "/forget-password",
        name: "ForgetPassword",
        component: ForgetPassword,
        meta: {
          title: "Forget Password",
        },
      },
      {
        path: "/login",
        name: "LoginPage",
        component: LoginPage,
        meta: {
          title: "login",
        },
      },
      {
        path: "/auto-login",
        name: "AutoLogin",
        component: AutoLogin,
        meta: {
          title: "auto login",
        },
      },
      {
        path: "/close-sift",
        name: "ShiftClosePage",
        component: ShiftClosePage,
        meta: {
          title: "close shift",
        },
      },
      {
        path: "/start-sift",
        name: "StartShiftPage",
        component: StartShiftPage,
        meta: {
          title: "start shift",
        },
      },
    ],
  },
  // Error Pages  :-
  {
    path: "/error500",
    name: "Error500",
    component: Error500,
  },
  {
    path: "/system_update",
    name: "SystemUpdate",
    component: SystemUpdate,
  },
  {
    path: "*",
    name: "Error404",
    component: Error404,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  store.commit("SET_ROUTE", to);
  next();
});

export default router;
